var _defs, _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarboncareLogoSmallInverted(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 279 194",
    width: 279,
    height: 194,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(155.294,0,0,36.997,53.075,176.66)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93c01f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#92bd23",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#8fb52f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#8aa743",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#a8bc78",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#eefccf",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.977,
    stopColor: "#f6fce3",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.99
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x2: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(36781.082,0,0,19125.984,3809.215,25022.223)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93c01f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.154,
    stopColor: "#92bd23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#8fb52f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#8aa743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    stopColor: "#83935e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#80896c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#6b705e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#595b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.919,
    stopColor: "#4e4e4b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4a49"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t\t.s1 { fill: #93c01f } \n\t\t.s2 { fill: url(#g1) } \n\t\t.s3 { fill: none } \n\t\t.s4 { fill: url(#g2) } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "svg_1",
    className: "s0",
    d: "m422.63 157.17l-3.45-5.66q-0.42 0.04-0.87 0.03h-4.48v5.63h-3.19v-18.69h7.67c4.84 0 7.62 2.33 7.62 6.38q0.07 0.97-0.17 1.92-0.25 0.95-0.78 1.77-0.53 0.81-1.29 1.42-0.76 0.61-1.68 0.95l4.24 6.25zm-4.32-8.46c2.92 0 4.59-1.23 4.59-3.77 0-2.45-1.67-3.63-4.59-3.63h-4.48v7.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_2",
    className: "s0",
    d: "m449.08 138.48v2.84h-10.32v5.07h9.24v2.8h-9.23v5.15h10.63v2.83h-13.83v-18.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_3",
    className: "s0",
    d: "m476.23 147.83c0 5.39-4.14 9.34-9.86 9.34h-7.67v-18.69h7.75c5.67 0 9.78 3.93 9.78 9.35zm-3.22 0.03q0.02-1.28-0.44-2.47-0.46-1.18-1.34-2.1-0.88-0.92-2.05-1.44-1.17-0.51-2.44-0.54-0.17 0-0.35 0h-4.5v13.03h4.65q1.25 0.04 2.42-0.41 1.17-0.45 2.08-1.3 0.91-0.87 1.43-2.01 0.51-1.14 0.54-2.4 0-0.18 0-0.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    className: "s0",
    d: "m492.92 154.48c3.08 0 5-1.87 5-5.05v-10.95h3.19v10.95c0 4.88-3.11 7.87-8.21 7.87-5.11 0-8.24-2.99-8.24-7.87v-10.95h3.19v10.95q-0.08 1.03 0.28 2 0.36 0.97 1.09 1.7 0.74 0.72 1.7 1.08 0.97 0.35 2 0.27z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_5",
    className: "s0",
    d: "m519.5 141.21c-1.76-0.07-3.47 0.58-4.75 1.78-1.29 1.21-2.03 2.88-2.08 4.63-0.04 1.76 0.62 3.47 1.85 4.74 1.22 1.26 2.89 1.99 4.65 2.01q0.17 0 0.33 0 0.73-0.02 1.45-0.17 0.72-0.16 1.39-0.44 0.68-0.29 1.29-0.69 0.61-0.4 1.14-0.92l1.89 2.09q-0.73 0.71-1.58 1.27-0.85 0.57-1.79 0.96-0.94 0.39-1.94 0.6-0.99 0.22-2.01 0.24c-1.25 0.04-2.5-0.17-3.67-0.61-1.17-0.45-2.24-1.11-3.15-1.97-0.92-0.86-1.65-1.89-2.17-3.03-0.51-1.14-0.8-2.37-0.84-3.62q0-0.14 0-0.28c0-5.31 4.35-9.4 9.94-9.4q0.99 0.01 1.97 0.2 0.98 0.19 1.9 0.56 0.92 0.37 1.76 0.9 0.83 0.54 1.56 1.23l-1.87 2.29q-0.51-0.55-1.11-0.98-0.61-0.44-1.28-0.74-0.68-0.31-1.41-0.47-0.73-0.16-1.47-0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_6",
    className: "s0",
    d: "m548.81 138.48v2.84h-10.32v5.07h9.24v2.8h-9.24v5.15h10.64v2.83h-13.83v-18.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_7",
    className: "s0",
    d: "m585.44 138.48v2.84h-10.32v5.07h9.24v2.8h-9.24v5.15h10.64v2.83h-13.83v-18.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_8",
    className: "s0",
    d: "m598.84 138.48l6.24 12.42 6.21-12.42h3.75v18.69h-2.94l-0.03-13.96-5.97 12.01h-2.08l-5.97-12.01v13.96h-3v-18.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_9",
    className: "s0",
    d: "m628.63 138.48v18.69h-3.18v-18.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_10",
    className: "s0",
    d: "m644.98 141.31c-1.87 0-3.08 0.7-3.08 1.95 0 4.09 10.2 1.9 10.18 8.63 0 3.33-2.97 5.39-7.13 5.39q-1.06-0.01-2.1-0.2-1.05-0.2-2.03-0.58-0.99-0.38-1.9-0.93-0.9-0.55-1.7-1.25l1.38-2.73q0.65 0.61 1.39 1.1 0.75 0.49 1.57 0.84 0.82 0.35 1.68 0.55 0.87 0.19 1.76 0.24c2.22 0 3.54-0.83 3.54-2.27 0-4.17-10.21-1.84-10.21-8.49 0-3.2 2.78-5.21 6.89-5.21q0.87 0 1.74 0.13 0.86 0.12 1.7 0.36 0.84 0.25 1.64 0.61 0.8 0.36 1.53 0.82l-1.32 2.78q-0.62-0.39-1.29-0.7-0.66-0.31-1.37-0.53-0.7-0.22-1.42-0.34-0.72-0.13-1.45-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_11",
    className: "s0",
    d: "m667.18 141.31c-1.87 0-3.08 0.7-3.08 1.95 0 4.09 10.21 1.9 10.18 8.63 0 3.33-2.97 5.39-7.13 5.39q-1.06-0.01-2.1-0.2-1.04-0.2-2.03-0.58-0.99-0.38-1.9-0.93-0.9-0.55-1.69-1.25l1.38-2.73q0.64 0.62 1.39 1.1 0.74 0.49 1.56 0.84 0.82 0.35 1.69 0.55 0.87 0.19 1.76 0.24c2.21 0 3.53-0.83 3.53-2.27 0-4.17-10.2-1.84-10.2-8.49 0-3.2 2.78-5.21 6.88-5.21q0.88 0 1.74 0.13 0.87 0.12 1.71 0.36 0.84 0.25 1.63 0.61 0.8 0.36 1.54 0.82l-1.32 2.78q-0.63-0.39-1.29-0.7-0.67-0.31-1.37-0.53-0.7-0.22-1.42-0.34-0.73-0.13-1.46-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_12",
    className: "s0",
    d: "m686.6 138.48v18.69h-3.19v-18.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_13",
    className: "s0",
    d: "m715.45 147.83c0 5.34-4.37 9.48-10.02 9.48-5.64 0-10.02-4.14-10.02-9.48 0-5.37 4.38-9.43 10.02-9.43 5.65 0 10.02 4.09 10.02 9.43zm-16.8 0q0.02 1.34 0.55 2.57 0.53 1.22 1.48 2.16 0.96 0.93 2.2 1.43 1.24 0.5 2.58 0.49c2.66-0.08 5.01-1.73 5.98-4.21 0.97-2.48 0.37-5.29-1.54-7.15-1.9-1.86-4.73-2.4-7.18-1.37-2.46 1.02-4.06 3.42-4.07 6.08z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_14",
    className: "s0",
    d: "m727.39 138.48l10.13 13.43v-13.43h3.13v18.69h-3.13l-10.07-13.4v13.4h-3.19v-18.69z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_15",
    className: "s0",
    d: "m757.02 141.31c-1.86 0-3.07 0.7-3.07 1.95 0 4.09 10.2 1.9 10.18 8.63 0 3.33-2.97 5.39-7.13 5.39q-1.06-0.01-2.1-0.2-1.05-0.2-2.04-0.58-0.98-0.38-1.89-0.93-0.9-0.55-1.7-1.25l1.38-2.73q0.65 0.62 1.39 1.1 0.75 0.49 1.57 0.84 0.82 0.35 1.68 0.55 0.87 0.19 1.76 0.24c2.22 0 3.54-0.83 3.54-2.27 0-4.17-10.21-1.84-10.21-8.49 0-3.2 2.78-5.21 6.89-5.21q0.87 0 1.74 0.13 0.86 0.12 1.7 0.36 0.84 0.25 1.64 0.61 0.8 0.36 1.53 0.82l-1.32 2.78q-0.62-0.39-1.29-0.7-0.66-0.31-1.37-0.53-0.7-0.22-1.42-0.34-0.72-0.13-1.46-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_16",
    className: "s0",
    d: "m320.98 122.36c-8.75 0-13.61-5.07-13.61-13.46v-17.31c0-8.38 4.86-13.45 13.61-13.45h36.25v10.42h-27.01c-6.57 0-8.28 1.89-8.28 11.7 0 10.27 1.78 11.7 8.28 11.7h27.01v10.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_17",
    className: "s0",
    d: "m409.69 122.36h-32.42c-9.23 0-14.09-4.46-14.09-14.27 0-8.85 4.85-12.44 14.09-12.44h28.59v8.73h-26.06c-1.98 0-3.28 0.6-3.28 3.78 0 2.77 1.02 3.79 3.21 3.79h20.66c6.5 0 8.27-1.42 8.27-11.7 0-9.81-1.64-11.7-8.27-11.7h-35.08v-10.41h44.38c8.69 0 13.62 5.07 13.62 13.45v17.31c-0.01 8.39-4.94 13.46-13.62 13.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_18",
    className: "s0",
    d: "m451.06 88.55c-5.81 0-6.9 1.35-6.9 7.51v26.3h-14.91v-30.77c0-8.38 4.85-13.45 13.61-13.45h13.61v10.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_19",
    className: "s0",
    d: "m508.04 122.36h-33.04c-8.76 0-13.61-5.07-13.61-13.45v-38.34h14.91v33.87c0 6.16 1.09 7.51 6.91 7.51h15.52c6.36 0 8.28-1.42 8.28-11.63 0-10.48-1.92-11.77-8.28-11.77h-20.04v-10.41h29.35c8.68 0 13.54 5.07 13.54 13.45v17.31c0 8.39-4.86 13.46-13.54 13.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_20",
    className: "s0",
    d: "m574.17 122.36h-33.04c-8.75 0-13.61-5.07-13.61-13.45v-17.32c0-8.38 4.86-13.45 13.61-13.45h33.04c8.69 0 13.54 5.07 13.54 13.45v17.31c0 8.39-4.85 13.46-13.54 13.46zm-9.3-33.81h-14.5c-6.57 0-8.28 1.9-8.28 11.7 0 10.28 1.78 11.7 8.28 11.7h14.5c6.36 0 8.28-1.28 8.28-11.7 0-10.21-1.92-11.7-8.28-11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_21",
    className: "s0",
    d: "m639 122.36v-30.02c0-3.38-0.41-3.79-3.21-3.79h-24.01c-2.8 0-3.21 0.41-3.21 3.79v30.02h-14.91v-44.22h46.64c8.75 0 13.61 5.07 13.61 13.45v30.77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_22",
    className: "s1",
    d: "m673.48 122.36c-8.76 0-13.62-5.07-13.62-13.45v-17.32c0-8.38 4.86-13.45 13.62-13.45h36.24v10.42h-27.01c-6.57 0-8.28 1.89-8.28 11.7 0 10.27 1.78 11.7 8.28 11.7h27.01v10.41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_23",
    className: "s1",
    d: "m762.18 122.36h-32.42c-9.24 0-14.1-4.46-14.1-14.27 0-8.85 4.86-12.44 14.1-12.44h28.58v8.73h-26.05c-1.99 0-3.28 0.6-3.28 3.78 0 2.77 1.02 3.79 3.21 3.79h20.65c6.5 0 8.28-1.42 8.28-11.7 0-9.81-1.64-11.7-8.28-11.7h-35.08v-10.41h44.39c8.68 0 13.61 5.07 13.61 13.45v17.31c0 8.39-4.93 13.46-13.61 13.46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_24",
    className: "s1",
    d: "m803.55 88.55c-5.81 0-6.91 1.35-6.91 7.51v26.3h-14.91v-30.77c0-8.38 4.86-13.45 13.61-13.45h13.61v10.42z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_25",
    className: "s1",
    d: "m859.84 104.85h-28.52v-8.73h25.98c1.98 0 3.28-0.6 3.28-3.78 0-2.77-1.02-3.79-3.21-3.79h-20.65c-6.5 0-8.28 1.49-8.28 11.77 0 9.73 1.71 11.63 8.28 11.63h35.15v10.41h-44.38c-8.75 0-13.61-5.07-13.61-13.45v-17.32c0-8.38 4.86-13.45 13.61-13.45h32.35c9.24 0 14.16 4.47 14.16 14.27 0 8.85-4.93 12.44-14.16 12.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_26",
    className: "s2",
    d: "m168.03 159.32q-4.86 3.4-10.18 6.03-5.32 2.62-10.98 4.4-5.65 1.79-11.52 2.68-5.86 0.9-11.79 0.89c-2.89 0-8.38-0.09-10.94-0.35l-0.41-0.07c-15.75 2.49-35.1-0.47-59.13-12.4l1.67 2.1c0.56 0.7 13.96 17.35 35.55 25.66 9.38 3.34 19.21 5.25 29.16 5.66 9.94 0.41 19.9-0.69 29.52-3.26 9.62-2.57 18.79-6.58 27.21-11.9 8.43-5.31 16-11.86 22.46-19.44z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_27",
    className: "s0",
    d: "m227.07 147.32c-2.21 0.03-4.19 1.38-5.02 3.43-0.83 2.05-0.35 4.39 1.22 5.95 1.58 1.56 3.93 2.01 5.97 1.16 2.04-0.85 3.37-2.84 3.37-5.05q0-1.1-0.43-2.11-0.42-1.02-1.2-1.79-0.78-0.77-1.8-1.18-1.01-0.41-2.11-0.41zm-0.08 7.99c-1.01-0.01-1.92-0.63-2.3-1.57-0.38-0.94-0.16-2.01 0.56-2.72 0.72-0.72 1.8-0.93 2.73-0.54 0.94 0.39 1.55 1.31 1.55 2.32q-0.01 0.5-0.2 0.97-0.19 0.46-0.55 0.81-0.36 0.36-0.82 0.55-0.47 0.18-0.97 0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_28",
    className: "s0",
    d: "m242.52 149.83q0.06-0.85 0.07-1.69 0.01-0.85-0.03-1.69-0.04-0.84-0.12-1.68-0.09-0.85-0.22-1.68l-3.9-6.03-3.55-9.4q-0.29-0.88-0.84-1.63-0.54-0.75-1.29-1.29-0.76-0.54-1.64-0.83-0.88-0.28-1.81-0.28h-17.55q-0.69 0-1.32 0.26-0.63 0.25-1.12 0.73-0.49 0.49-0.75 1.12-0.27 0.63-0.27 1.31v26.33h11.68q-0.03-0.39 0-0.78 0.02-0.38 0.08-0.76 0.07-0.38 0.18-0.76 0.11-0.37 0.26-0.72 0.38-0.88 0.98-1.64 0.6-0.75 1.38-1.31 0.78-0.57 1.68-0.91 0.9-0.34 1.85-0.43 1.4-0.13 2.73 0.28 1.34 0.41 2.42 1.3 1.08 0.89 1.74 2.13 0.66 1.24 0.79 2.63 0.03 0.31 0.03 0.63 0 0.17-0.01 0.34h8.75q0.14 0 0.26-0.05 0.13-0.04 0.23-0.13 0.1-0.09 0.16-0.21 0.06-0.12 0.08-0.25l0.15-1.3q0-0.26-0.07-0.51-0.08-0.25-0.22-0.46-0.15-0.22-0.35-0.38-0.2-0.16-0.44-0.26zm-28.45-14.03v-10.35h9.34l1.73 10.35zm13.85-0.34l-1.73-9.78h3.25q0.42 0 0.82 0.13 0.4 0.13 0.73 0.38 0.34 0.25 0.58 0.6 0.23 0.34 0.35 0.75l2.71 7.92z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_29",
    fillRule: "evenodd",
    className: "s0",
    d: "m164.47 151.33h40.75v-31.06h-12.06l-28.69 31.06z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_30",
    className: "s1",
    d: "m0 114.05c0 0 20.4 24.34 51.24 38.75 87.17 40.72 125.98-43.92 135.51-61.88-3.93 1.9-55.1 22.94-85.49 26.1-41.25 4.29-61.87-0.45-61.87-0.45 0 0 58.1-1.71 111.89-24.88-36.64-34.78-73.59-24.45-99.36-2.17-25.56 22.11-51.92 24.53-51.92 24.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_31",
    className: "s3",
    d: "m256.94 86.2c1.05 0.06 1.97-1.05 2.04-2.47 0.08-1.43-0.71-2.64-1.76-2.7-1.06-0.07-1.97 1.04-2.05 2.47-0.07 1.43 0.72 2.64 1.77 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_32",
    className: "s4",
    d: "m210.5 52.14c-8.55-16.02-21.36-29.36-37.02-38.56-15.65-9.2-33.54-13.89-51.69-13.57-18.16 0.33-35.87 5.66-51.18 15.42-15.32 9.75-27.64 23.55-35.61 39.86l-15.12-5.23 7.91 49.06 43.51-34.47-15.07-4.9c6.01-10.5 14.38-19.44 24.45-26.12 10.08-6.69 21.58-10.92 33.58-12.38 12-1.45 24.17-0.07 35.55 4.01 11.38 4.09 21.64 10.78 29.97 19.54l24.5 5.86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_33",
    className: "s0",
    d: "m258.06 46.5c-3.78-1.96-9.39-2.98-19.1-0.37-9.71 2.61-72.56 24.64-72.56 24.64-3.18-0.17-13.38-7.4-13.38-7.4 0 0-8.2 0.94-7.87 1.31 1.18 1.3 12.27 20.64 14.99 22.54 1.23 0.85 4.22 0.58 10.69-1.15 6.47-1.74 33.93-11.4 33.93-11.4l-10.8 40.34c0 0 7.89-1.66 10.93-5.34 2.71-3.29 18.4-36.2 21.74-43.26 8.51-3.7 18.63-8.08 21.62-9.26 5.43-2.15 8.32-3.03 10.93-5.34 2.61-2.3 2.66-3.35-1.12-5.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_34",
    className: "s0",
    d: "m186.04 59.56l17.34-6.04-34.35-8.21q-0.49-0.11-0.99-0.17-0.5-0.06-1.01-0.06-0.5 0-1 0.05-0.5 0.06-0.99 0.17c-2.84 0.66-7.5 1.81-5.9 1.9 1.06 0.06 26.9 12.36 26.9 12.36z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_35",
    className: "s3",
    d: "m234.54 109.59c-4.04-4-13.06-5.6-22.37-6.07q-1.25 2.4-2.26 4.23 3.07-0.68 6.2-0.91 3.12-0.22 6.25 0.02 3.13 0.23 6.19 0.92 3.06 0.69 5.99 1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_36",
    className: "s3",
    d: "m256.94 86.19c1.06 0.06 1.97-1.04 2.05-2.47 0.07-1.43-0.72-2.64-1.77-2.7-1.05-0.07-1.97 1.04-2.04 2.47-0.08 1.43 0.71 2.64 1.76 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_37",
    className: "s0",
    d: "m186.68 102.62c0 0 3.28-0.4 7.97-0.67l1.28-4.78q-1.22 0.56-2.41 1.19-1.19 0.62-2.35 1.31-1.15 0.68-2.28 1.42-1.12 0.74-2.21 1.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_38",
    className: "s0",
    d: "m251.37 113.8l19.23-40.34c0 0-26.09 6.01-50.61 14.45-2.76 5.65-5.54 11.25-7.82 15.61 9.31 0.47 18.32 2.07 22.37 6.08q-2.93-1.13-5.99-1.82-3.06-0.69-6.19-0.92-3.13-0.23-6.25-0.01-3.13 0.22-6.2 0.9-0.95 1.73-1.61 2.78-1.12 2.08-2.36 4.08 3.76-0.84 7.61-1.01 3.85-0.17 7.67 0.34 3.82 0.52 7.49 1.7 3.67 1.17 7.08 2.98c33.2 17.63 43.29-4.41 43.29-4.41-1.99 1.52-4.21 2.69-6.58 3.47-2.37 0.78-4.85 1.15-7.35 1.12-2.49-0.04-4.96-0.49-7.31-1.34-2.34-0.85-4.53-2.09-6.47-3.66zm5.85-32.77c1.05 0.06 1.84 1.27 1.77 2.7-0.08 1.43-0.99 2.54-2.04 2.47-1.06-0.06-1.85-1.27-1.77-2.7 0.07-1.43 0.99-2.54 2.04-2.47z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_39",
    className: "s3",
    d: "m246.34 75.67c3.12-0.87 6.06-1.67 8.72-2.37v-1.83l-8.72-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_40",
    className: "s3",
    d: "m235.03 72.2v2.98l-2.73-0.88v5.47q1.37-0.42 2.73-0.83 1.98-0.6 3.92-1.16 3.52-1.03 6.83-1.95v-6.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_41",
    className: "s3",
    d: "m225.55 76.42q-0.82 1.7-1.69 3.5l-0.19 0.41q-0.63 1.29-1.26 2.6 0.63-0.21 1.26-0.42 1.56-0.51 3.12-1.01 2.55-0.82 5.07-1.59v-5.47z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarboncareLogoSmallInverted);
export default __webpack_public_path__ + "static/media/carboncare_logo_small_inverted.8fb07596aedcade5df275edac6ce4d9c.svg";
export { ForwardRef as ReactComponent };